function handleRequest({ retailRequest, variantName, pricePromise, getGraphURL, apolloClientInfo }) {
    if (retailRequest) {
        const priceApiPromises = [
            pricePromise({
                request: retailRequest,
                getGraphURL,
                apolloClientInfo
            })
        ];
        if ('EXPRESS' === variantName) {
            const expressOWRequest = {
                ...retailRequest,
                sopq: true
            };
            priceApiPromises.push(pricePromise({
                request: expressOWRequest,
                getGraphURL,
                apolloClientInfo
            }));
        }
        return Promise.all(priceApiPromises);
    }
    return Promise.resolve(null);
}
export { handleRequest };
